import { gql } from '@apollo/client';

export const TRIGGER_KB_DOCUMENT_SYNC = gql`
  mutation TriggerKbDocumentSync {
    triggerKbDocumentSync {
      statusCode
      message
    }
  }
`;
